// Notes:
// Each question inc. label and field(s) should be wrapped with a class called .sq-form-question
// aria-described is being added and removed for error messaging accessibility purposes

export default class SimpleFormValidation {
  form;
  constructor(form) {
    // Initialise ARIA
    this.form = form;
  }
  validate() {
    const formElements = this.form.elements;

    // Keep track of which fields have been checked
    // So that don't need to loop through each radio/checkbox in a group
    let checkedFields = [];

    // To focus on when validation check has finished for accessibility reasons
    let focusErrorField;

    // Remove all existing errors
    // Loop through each question group with this error class
    this.form
      .querySelectorAll(".sq-form-question-error")
      .forEach((questionGroup) => {
        // Remove question group error class
        questionGroup.classList.remove("sq-form-question-error");

        // Remove aria-describedby attribute applied on fields within the group
        // Loop through checkboxes / radios
        questionGroup
          .querySelectorAll("[aria-describedby]")
          .forEach((elField) => {
            elField.removeAttribute("aria-describedby");
          });

        // Remove error message element
        let elErrorMessage = questionGroup.querySelector(".sq-form-error");

        if (elErrorMessage) {
          elErrorMessage.remove();
        }
      });

    // Perform validation
    // Loop through each of this form's elements
    for (let i = 0, j = formElements.length; i < j; ++i) {
      let isValidated = false;

      let formElement = formElements[i];

      let formElementName = formElement.name;

      // Selector needs colons (which exist in Matrix field names) to be escaped
      let escapedFormElementName = formElementName.replaceAll(
        /(:|\[|\])/g,
        "\\$1"
      );

      // If this field name doesn't exist in the array of validated
      // It means we haven't checked this field name / group yet
      if (checkedFields.indexOf(formElementName) === -1) {
        let formElementType = formElement.type;

        let errorMessage = "";

        if (
          formElementName === "" ||
          formElement.disabled ||
          formElementType === "submit" ||
          formElementType === "hidden"
        ) {
          // Skip the undefined, disabled elements, submit button and hidden fields
          continue;
        }

        switch (formElementType) {
          case "text":
          case "email":
          case "tel":
          case "date":
          case "number":
          case "url":
          case "color":
          case "datetime-local":
          case "textarea":
          case "select-one":
          case "select-multiple":
          case "range":
          case "file":
            if (formElement.checkValidity()) {
              isValidated = true;
            } else {
              errorMessage = formElement.validationMessage;

              if (!focusErrorField) {
                focusErrorField = formElement;
              }
            }

            break;

          case "radio":
          case "checkbox": {
            // Get all the input fields of this group
            let elInputFields = this.form.querySelectorAll(
              `input[name=${escapedFormElementName}]`
            );

            // Loop through each one
            for (let i = 0, j = elInputFields.length; i < j; ++i) {
              let inputField = elInputFields[i];

              // If this one passes validity,
              if (inputField.checkValidity()) {
                // Update validation flag
                isValidated = true;

                // Don't need to check the rest
                break;
              } else {
                if (
                  inputField.type === "checkbox" &&
                  inputField.validity.valueMissing
                ) {
                  // Assuming that if all checkboxes are marked as required
                  // And Only one needs to be checked
                  // Specify unique error msg instead of default
                  // e.g. "Please tick this box to continue"
                  errorMessage = "Please select one of these options";
                } else {
                  // Use default
                  errorMessage = inputField.validationMessage;
                }
              }
            }

            // If all checkboxes/radios didn't pass validation
            // And no focus error field is set yet
            if (!isValidated && !focusErrorField) {
              // Make the first field focused
              focusErrorField = elInputFields[0];
            }

            break;
          }
        }

        // If validation has failed for this field
        // Add error message
        if (!isValidated) {
          // Create the errpr message element
          let errorMsgElement = document.createElement("p");

          // Construct id of error message element
          let errorElementID = formElementName + "__error";

          // Add id so that aria-describedby applied on fields will point to error message
          errorMsgElement.setAttribute("id", errorElementID);

          // Add class for styling
          errorMsgElement.classList.add("sq-form-error");

          // Add the error message text into the error message element
          errorMsgElement.innerHTML = errorMessage;

          // Add error message element in to form question group
          formElement.closest(".sq-form-question").appendChild(errorMsgElement);

          // querySelectorAll used to add this attribute to all related radios and checkboxes
          this.form
            .querySelectorAll(`[name=${escapedFormElementName}]`)
            .forEach((formElement) => {
              formElement.setAttribute("aria-describedby", errorElementID);
            });

          // Add error class to form question group for styling
          formElement
            .closest(".sq-form-question")
            .classList.add("sq-form-question-error");
        }

        checkedFields.push(formElementName);
      }
    }

    // Validatin has finished.
    // What's the outcome and action from this?
    if (!focusErrorField) {
      return true;
    } else {
      focusErrorField.focus();
      return false;
    }
  }
}
